import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  message,
  Switch,
  Skeleton,
  Space,
  InputNumber,
} from "antd";
import { gql, useMutation } from "@apollo/client";
import UploadFile from "@general/UploadFile";

const WorkSpacePackageForm
 = ({ formData, onDoUpdateData, packageId, productId }) => {

  const UPDATEPACKAGE = gql`
    mutation updateWSPackage(
      $updateWSPackageInput: UpdateWSPackageInput!
      $id: ID!
    ) {
      updateWSPackage(updateWSPackageInput: $updateWSPackageInput, id: $id)
    }
  `;
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);

  const [form] = Form.useForm();
  const [runUpdatePackage, updatePackage] = useMutation(UPDATEPACKAGE, {
    onCompleted() {
      message.success("پکیج بروزرسانی شد.");
      onDoUpdateData();
    },
    onError(err) {
      console.log("خطا: " + err.message);
      message.error("مشکلی پیش آمده! پکیج بروزرسانی نشد.");
    },
  });

  const doUpdatePackage = (updateWSPackageInput) => {
    runUpdatePackage({
      variables: {
        id: packageId,
        updateWSPackageInput: {
          ...updateWSPackageInput,
          productId,
        },
      },
    });
  };
  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData]);

  if (updatePackage?.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>
      <Row>
        <Space align>
          <p>ویرایش: </p>
          <Switch onChange={() => setEditable(!editable)} />
        </Space>
      </Row>
      <Form
        layout="vertical"
        onFinish={doUpdatePackage}
        form={form}
        disabled={!editable}
      >
        <Row gutter={15}>
          <Col xs={24} lg={24}>
            <Row gutter={15}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  label="نام پکیج"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نام پکیج را وارد کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <Input className="form-input" placeholder="نام پکیج" />
                </Form.Item>

                <Form.Item
                  name="amountRial"
                  label="هزینه (ریال)"
                  rules={[
                    {
                      required: true,
                      message: "لطفا هزینه را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا هزینه را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    formatter={(value) =>
                      value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                    className="form-input"
                    placeholder={"هزینه"}
                    style={{ textAlign: "left", width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  name="days"
                  label="تعداد روز"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تعداد روز را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا تعداد روز را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    formatter={(value) =>
                      value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                    className="form-input"
                    placeholder={"تعداد جلسات"}
                    style={{ textAlign: "left", width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  name="remider1"
                  label="تعداد روز یادآور اول"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تعداد روز را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا تعداد روز را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    formatter={(value) =>
                      value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                    className="form-input"
                    placeholder={"روز"}
                    style={{ textAlign: "left", width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="image"
                  label="پوستر"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تصویر پکیج آپلود کنید!",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <UploadFile />
                </Form.Item>
                <Form.Item
                  name="strikethroughRial"
                  label="قیمت خط خورده (ریال)"
                  rules={[
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا قیمت را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    formatter={(value) =>
                      value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                    className="form-input"
                    placeholder={"قیمت خط خورده"}
                    style={{ textAlign: "left", width: "100%" }}
                  />
                </Form.Item>
                <Form.Item
                  name="remider2"
                  label="تعداد روز یادآور دوم"
                  rules={[
                    {
                      required: true,
                      message: "لطفا تعداد روز را وارد کنید!",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "لطفا تعداد روز را به طور صحیح وارد کنید",
                    },
                  ]}
                  validateStatus={error && "error"}
                >
                  <InputNumber
                    formatter={(value) =>
                      value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                    className="form-input"
                    placeholder={"روز"}
                    style={{ textAlign: "left", width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row></Row>
            <Row>
              <Col span={24}>
                <Form.Item label="توضیحات" name="description">
                  <Input.TextArea rows={2} placeholder="توضیحات" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Button
          type="primary"
          htmlType="submit"
          loading={updatePackage.loading && true}
        >
          بروزرسانی پکیج
        </Button>
      </Form>
    </>
  );
};

export default WorkSpacePackageForm;
